import React from 'react';
import SelectionDropDown from './SelectionDropdown';
import { ProductPriceString } from '../utils/ProductPriceString';
import { successTickImageUrl } from '../utils/Constants';

const BundlerProducts = ({
  categoryData,
  setCartItems,
  cartItems,
  finalArray,
  setFinalArray,
  selectArray,
  setSelectArray,
  detailsModal,
  setDetailsModal,
  productList,
  setProductList,
}) => {
  const handleProductAdd = (productId, productDetails) => {
    let selected = selectArray.find(item => item.productId === productId);
    if (cartItems.indexOf(productId) === -1) {
      setCartItems(oldArray => [...oldArray, productId]);
      setFinalArray(oldArray => [
        ...oldArray,
        {
          productId,
          variantId: selected.id,
          optionsValue: selected.value,
          categoryName: categoryData.categoryName,
          productName: productDetails.productName,
          productImage: productDetails.url_image,
        },
      ]);
      setProductList(oldArray => [...oldArray, selected.id]);
    }
  };

  function handleRemoveProduct(productId) {
    const removedId = finalArray.find(e => e.productId == productId).variantId;
    setCartItems(cartItems.filter(e => e !== productId));
    setFinalArray(finalArray.filter(e => e.productId !== productId));
    setProductList(productList.filter(e => e !== removedId));
  }

  function getOptionName(productId) {
    return finalArray.filter(e => e.productId === productId)[0].optionsValue;
  }

  return categoryData.products.map((Product, index) => {
    const singleProduct = Product.productDetails;
    const productId = singleProduct.parentProductId;
    const activeProduct = cartItems.includes(productId);
    return (
      <div className="xrs-bundler-product-wrapper" key={index}>
        <div
          className="xrs-product__image-name-container"
          onClick={() =>
            setDetailsModal({ show: true, details: singleProduct })
          }
        >
          <div className="xrs-product__image-container">
            {activeProduct && (
              <img
                src={successTickImageUrl}
                alt="success"
                className="cart-success-img"
              />
            )}
            <img
              src={singleProduct.url_image}
              // Ensure HTML encoded entities display properly
              alt={singleProduct.variantName}
              className="xrs-product__image"
              width="50px"
              height="50px"
            />
          </div>
          <div className="xrs-product-name-price">
            {singleProduct.options.length === 1 ? (
              <p data-testid="productname">
                {singleProduct.productName +
                  `, ` +
                  singleProduct.options[0].value}
              </p>
            ) : (
              <p data-testid="productname">
                {singleProduct.productName}
                {activeProduct && <span>, {getOptionName(productId)}</span>}
              </p>
            )}
            <ProductPriceString
              price={singleProduct.price}
              compareAtPrice={singleProduct.compareAtPrice}
              currency={singleProduct.currency}
            />
          </div>
        </div>
        <div className="xrs-product__selection-cart">
          {!activeProduct && (
            <SelectionDropDown
              singleProduct={singleProduct}
              setSelectArray={setSelectArray}
              selectArray={selectArray}
            />
          )}
          <div className="xrs-product-add">
            {activeProduct ? (
              <div className="xrs-product__added-cart">
                added to cart{' '}
                <a onClick={() => handleRemoveProduct(productId)}>Remove</a>
              </div>
            ) : (
              <button
                className="bundler-button"
                onClick={() => handleProductAdd(productId, singleProduct)}
              >
                {' '}
                + Add
              </button>
            )}
          </div>
        </div>
      </div>
    );
  });
};

export default BundlerProducts;
